module.exports = __webpack_public_path__ + "img/p4-c2-p1.4f8a4575.jpg";